const selectCard = (state = { isProcessing: true }, action) => {
  switch (action.type) {
    case 'GET_CARDS':
      return {
        ...state,
        isProcessing: true,
      };
    case 'GET_CARDS_SUCCESS':
      return {
        ...state,
        cards: action.data,
        isProcessing: false,
      };
    case 'GET_CARDS_FAIL':
      return {
        ...state,
        error: action.error,
        isProcessing: false,
      };
    case 'SET_CARD':
      return {
        ...state,
        selectedCard: action.card,
      };
    default:
      return state;
  }
};

export default selectCard;
